import React from "react"
import { Link } from "react-router-dom"
import { ROUTE_PATHS } from "../utils/routes"
import { Button, LinkButton } from "./styled"
import AnalyticsService from "../utils/AnalyticsService"
import { GA4_EVENTS, CUSTOMER_TYPES } from "../utils/ga4Events"
import PropTypes from "prop-types"
import { EXTERNAL_ROUTE_PATHS } from "../utils/externalRoutes"

export const GetStartedComponent = ({ isBroadband, isT2T }) => {

  const sendEventAnalytic = (analyticText) => {

    AnalyticsService.sendGa4Event({ event: 'hookup_lookup', category: "Landing", action: analyticText, label: "continue" })
    if ('not_current_tmo' === analyticText) {
      // GA4 funnel: customer type selected – Non-T-Mobile
      AnalyticsService.sendGA4FunnelEvent(GA4_EVENTS.CUSTOMER_TYPE_SELECTED, {
        customer_type: CUSTOMER_TYPES.NON_TMO,
      })
      window.location.assign(ROUTE_PATHS.EXCLUSIVECODE)
    }
    else if ('current_tmo_customer' === analyticText) {
      // GA4 funnel: customer type selected – T-Mobile + login initiated
      AnalyticsService.sendGA4FunnelEvent(GA4_EVENTS.CUSTOMER_TYPE_SELECTED, {
        customer_type: CUSTOMER_TYPES.TMO,
      })
      AnalyticsService.sendGA4FunnelEvent(GA4_EVENTS.LOGIN_INITIATED, {
        method: 'tmo_id',
      })
      window.location.assign(process.env.REACT_APP_TMO_ID_AUTH_URL)
    }

  }

  return (
    <section>
      <div className="container pt-5 pb-3 hero3">
        <div className="row no-gutters2 text-center">
          <div className="col">
            {isT2T && <>
              <h1 className="magenta exclusive-header font-teleNeoWeb">You received a special <span style={{ "display": "inline-block" }}>Tunnel to Towers T-Mobile</span> discount.</h1>
              <p className="text-center">Once your T-Mobile service is active, enter your code to access amazing benefits.</p>
            </>
            }
            {!isT2T &&
              <h1 className="magenta exclusive-header font-teleNeoWeb">You scored a special <span style={{ "display": "inline-block" }}>T-Mobile</span> discount.</h1>
            }
            {isBroadband && <>
              <br></br>
              <p className="text-center">Enter your code to access amazing benefits.</p>
              <p className="text-center" >Please find your assigned billing phone number on your bill under <Link to={ROUTE_PATHS.FAQ}>"connected devices"</Link>.</p><br></br></>}
            {!isBroadband && !isT2T && <>
              <p className="text-left mb-3" >Enter your code to access amazing benefits. Then - visit <Link to={{ pathname: EXTERNAL_ROUTE_PATHS.TMO_JOIN }} target="_blank">Switch to T-Mobile</Link> to join us!</p>
              <p className="text-left mb-3" >If you are a Home Internet only customer, please find your assigned billing phone number on your bill under  <Link to={ROUTE_PATHS.FAQ}>"connected devices"</Link>.</p></>}
          </div>
        </div>

        {(isBroadband || isT2T) && <div className="col-md-12 text-center">
          <LinkButton className="btn" id="btnSubmit"
            href={process.env.REACT_APP_TMO_ID_AUTH_URL}
            onClick={() => sendEventAnalytic('current_tmo_customer')}
            primary>Click here to enter promo code</LinkButton>
        </div>}

        {(!isBroadband && !isT2T) && <div className="row no-gutters2 text-center">
          <div className="col-md-6">
            <Button onClick={() => sendEventAnalytic('not_current_tmo')} className="btn-primary1" style={{ "marginBottom": "15px" }}>
              I am not a current T-Mobile Customer
            </Button>
          </div>
          <div className="col-md-6">
            <Button className="btn-primary1" type="button" aria-expanded="false" style={{ "marginBottom": "15px" }} onClick={() => sendEventAnalytic('current_tmo_customer')} >
              I am a current T-Mobile Customer
            </Button>
          </div>
        </div>}
      </div>
    </section>
  )
}

GetStartedComponent.propTypes = {
  isBroadband: PropTypes.bool
}